import { render } from "./SystemConfig.vue?vue&type=template&id=6f0f0a34&scoped=true"
import script from "./SystemConfig.vue?vue&type=script&lang=js"
export * from "./SystemConfig.vue?vue&type=script&lang=js"

import "./SystemConfig.vue?vue&type=style&index=0&id=6f0f0a34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0f0a34"]])

export default __exports__